import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

export const LIBRARY_CREATIVE_ROUTE = `/${ENTITY_TO_PATH_MAP[ENTITY.LIBRARY_CREATIVE]}`;
export const CREATIVE_ID_PARAM_NAME = 'creativeId';
export const CREATIVE_ID_PARAM_TEMPLATE = `/:${CREATIVE_ID_PARAM_NAME}?`;
